import { Avatar, Button, Menu, MenuItem } from '@mui/material';
import { useState, type JSX, type MouseEvent } from 'react';
import { useMe } from '../api/hooks/useMe';
import { useAuthState } from '../auth/AuthProvider';

/** docs/design/MUI-Komponenten.md "Shell": Button + Avatar -> Menu/MenuItem (Nutzermenü, F-19). */
export function UserMenu(): JSX.Element {
  const { data } = useMe();
  const { logout } = useAuthState();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const name = data?.name ?? '';
  const initial = name.charAt(0).toUpperCase() || '?';

  return (
    <>
      <Button
        data-testid="user-menu-button"
        color="inherit"
        onClick={(event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)}
        startIcon={<Avatar sx={{ width: 28, height: 28 }}>{initial}</Avatar>}
      >
        {name}
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem data-testid="user-menu-logout" onClick={logout}>
          Abmelden
        </MenuItem>
      </Menu>
    </>
  );
}
